import memoizeOne from 'memoize-one';
export var eventMemoryPlugin = memoizeOne(function () {
  // @ts-ignore: deviceMemory is exposed in some browsers
  if (!navigator.deviceMemory) {
    return null;
  }
  return {
    // @ts-ignore
    'event:memory': navigator.deviceMemory
  };
});